import api from "../config/api";
import { Message, MessageType } from "../models/Message";
import { ServiceReturn } from "../types/ServiceResponse";
import { UploadedFileReference } from "./uploadServices";

interface StickerReferenceFields {
  id?: string;
  fileId?: string | null;
  storageKey?: string | null;
  url?: string | null;
};

interface SavedStickerPayload {
  fileMetadataId: string;
  savedAt: string;
  fileMetadata?: Partial<UploadedFileReference> | null;
};

export interface SavedSticker {
  id: string;
  name: string;
  savedAt: string;
  fileMetadata: UploadedFileReference;
};

const moduleBaseUrl = "user/saved-sticker";

export const getStickerReference = ( fileMetadata?: StickerReferenceFields | null ) => fileMetadata?.fileId || fileMetadata?.storageKey || fileMetadata?.url || fileMetadata?.id || "";

export const normalizeSavedSticker = ( payload: SavedStickerPayload ): SavedSticker | null => {
  const fileMetadata = payload.fileMetadata;
  const id = payload.fileMetadataId || fileMetadata?.id;
  if( !id || !fileMetadata ) return null;

  const fileName = fileMetadata.fileName || "Figurinha";

  return {
    id,
    name: fileName,
    savedAt: payload.savedAt,
    fileMetadata: {
      id,
      fileId: fileMetadata.fileId || "",
      storageKey: fileMetadata.storageKey || fileMetadata.url || "",
      thumbnailKey: fileMetadata.thumbnailKey || null,
      mimeType: fileMetadata.mimeType || "image/webp",
      fileName,
      originalFileName: fileMetadata.originalFileName || null,
      size: fileMetadata.size || 0,
      extension: fileMetadata.extension || null,
      sha256: fileMetadata.sha256 || null,
      durationSeconds: fileMetadata.durationSeconds || null,
      pageCount: fileMetadata.pageCount || null,
      width: fileMetadata.width || null,
      height: fileMetadata.height || null,
      url: fileMetadata.url || null,
      thumbnailUrl: fileMetadata.thumbnailUrl || null,
      uploadStatus: fileMetadata.uploadStatus || "COMPLETED",
    },
  };
};

export const normalizeSavedStickers = ( stickers?: SavedStickerPayload[] | null ): SavedSticker[] => {
  if( !Array.isArray( stickers )) return [];
  return stickers.map( normalizeSavedSticker ).filter(( sticker ): sticker is SavedSticker => Boolean( sticker ));
};

export const saveStickerFromMessage = async ( message: Message ): Promise<ServiceReturn<SavedSticker>> => {
  if( message.messageType !== MessageType.STICKER || !message.fileMetadata?.id ) {
    return {
      data: false,
      message: "Figurinha sem metadados para salvar",
    };
  }

  try {
    const { data } = await api.post(`/${ moduleBaseUrl }`, {
      fileMetadataId: message.fileMetadata.id,
    });

    if( data?.data ) {
      data.data = normalizeSavedSticker( data.data ) || false;
    }

    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};

export const removeSavedSticker = async ( stickerId: string ): Promise<ServiceReturn<boolean>> => {
  try {
    const { data } = await api.delete(`/${ moduleBaseUrl }/${ stickerId }`);
    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};
